import { motion } from "framer-motion";
import Container from "./Container";
import Button from "./Button";

export default function CTASection({
  title = "Ready to Get Started?",
  subtitle = "Book a free consultation with our experts today.",
  primaryLabel = "Get Free Consultation",
  primaryHref = "/contact",
  secondaryLabel,
  secondaryHref,
  className = "",
}) {
  return (
    <section className={`w-full py-20 lg:py-24 xl:py-32 ${className}`} style={{ background: "var(--gradient-primary)" }}>
      <Container>
        <div className="text-center">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4"
          >
            {title}
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-lg text-white/80 mb-8 max-w-2xl mx-auto"
          >
            {subtitle}
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="flex flex-wrap gap-4 justify-center"
          >
            <Button variant="primary" href={primaryHref} size="lg">{primaryLabel}</Button>
            {secondaryLabel && (
              <Button variant="ghost" href={secondaryHref} size="lg">{secondaryLabel}</Button>
            )}
          </motion.div>
        </div>
      </Container>
    </section>
  );
}
